let Url = {
    user: "http://127.0.0.1:3000/users",
    userGroup: "http://127.0.0.1:3000/usergroups",
    messages: "http://127.0.0.1:3000/messages",
    location: "http://127.0.0.1:3000/locations"
}
export default Url;


// WEBPACK FOOTER //
// ./src/components/apiConfig.js